import { ProjectData, Tags, Languages, Software, ProjectStatus, Products, Contributors, OtherLanguages, OtherProducts } from '@structures/ProjectData';
import { Title, Images, Downloads } from '@projects/Final Fantasy Tactics Mesiah Mod';
import { FileType } from '@models';

export const ImageAssets = Object.values(Images);

export const DownloadAssets = Object.values(Downloads);

export const FinalFantasyTacticsMesiahMod: ProjectData = {
    summary: {
        id: "FFTMM",
        title: "Final Fantasy Tactics: Mesiah Mod",
        aliases: ["Final Fantasy Tactics", "Final Fantasy", "Tactics", "War of the Lions", "FFT", "WOTL", "FFT: WOTL", "Mod", "Mesiah", "Patch"],
        filter: { settings: { pixelSize: 1 }},
        version: 0.85,
        status: ProjectStatus.Completed,
        initial: new Date(2015, 2, 1),
        release: new Date(2025, 5, 29),
        previews:[{
            file: Title.Title_01,
            type: FileType.Image,
            description: "An image of a the Final Fantasy Tactics War of the Lions Title screen with the patch information.",
            caption: `Title screen of the patch.`
        }],
        tags: {
            [Tags.Products]: [
                Products.Games,
                OtherProducts.Patches
            ],
            [Tags.Software]: [
                Software.VS
            ],
            [Tags.Languages]: [
                Languages.CSharp,
                OtherLanguages.PSP
            ]
        },
        description: "A thoughtful rebalancing of this classic Tactical RPG, includes new features and progressively more challenging late game."
    },
    details: {
        description: "A simple & fun spin on this classic Tactical RPG that introduces game concepts earlier and creates a more rewarding end game experience."
            + "<br/><br/>"
            + "It's an attempt to make the game easy to pickup and difficult to master."
            + "<br/><br/>"
            + "Introduces 4 new job classes: Berserker, Red Mage, Sage, Blade Master."
            + "<br/><br/>"
            + "Introduces 4 new monsters: Cactuar, Tonberry, Flan, Iron Giant."
            + "<br/><br/>"
            + "Introduces over 100 new skills to support all the new classes and monsters."
            + "<br/><br/>"
            + "Introduces over 40 new weapons, armors, and items to collect."
            + "<br/><br/>"
            + "Introduces 1 new recruitable unique character: Marche from Final Fantasy Tactics Advance!"
            + "<br/><br/>"
            + "Introduces 1 new super boss villain!"
            + "<br/><br/>"
            + "Reworks graphics in the game adding more variety to characters and their outfit choices for different parts of the story."
            + "<br/><br/>"
            + "Fixes the slowdown bug plaguging the PSP version."
            + "<br/><br/>"
            + "Rebalances the entire game to make it easier to start off and more difficult to master.",
        gallery: [{
                file: ImageAssets[0],
                type: FileType.Image,
                description: "Image showing Berseker, Red Mage, Sage, Blast Master, Cactuar, Tonberry, Flan, Iron Giant, Sephiroth as well as reskins of Cloud, Gafgarion, Agrias.",
                caption: "Showcase of all the new jobs, heroes, villains, and monsters."
            }, {
                file: DownloadAssets[0],
                type: FileType.Download,
                description: `<button class="rpgui-button">Download</button>`,
                caption: "First official release of the mod, apply it with a ppf patcher to the War of the Lions EU ISO."
            }],
        contributions: [{
            contributor: Contributors.MakoInfused,
            roles: [{
                title: "Gameplay Engineer",
                involvement: "Redeveloped the games items, weapons, skills and jobs according to specification.",
                achievements: [
                    "Modified existing tools to support custom changes to the game for modifying game data to the desired specifications.",
                    "Added code to support the gameplay of all new jobs, monsters, battles, and skills.",
                    "Wrote a some low level MIPS assembly code to support custom game logic."
                ]
            }, {
                title: "Game Designer",
                involvement: "Rebalanced the entire game to be simple in the early game and more difficult in the late game to create a rewarding experience.",
                achievements: [
                    "Designed new job classes: Berserker, Red Mage, Sage, Blade Master",
                    "Designed new monsters replacing the more tame choices in the game with ones classic to the Final Fantasy franchise: Cactuar, Tonberry, Flan, Iron Giant",
                    "Rebalanced all: items, battles, units, job classes, skills, monsters."
                ]
            }]
        }]
    },
};

export default FinalFantasyTacticsMesiahMod;